export default __webpack_public_path__ + "static/banner-1a24e75d27dd9379f08463208ab186da.jpg";